var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47818 14.5238L0.0488281 10.0945L4.47818 0.974121L8.90752 10.0945L4.47818 14.5238Z",
    fill: "#3D9AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.f34c02ab0a6dadeeb2de37fa94a5c605.svg";
export { ForwardRef as ReactComponent };